<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box">
      <b-col md="4" order-md="3" class="text-right">
        <template v-if="freeDay.canEdit">
          <b-button class="btn btn-success edit" @click.prevent="editFreeDay">
            <font-awesome-icon icon="pencil-alt" size="xs"></font-awesome-icon>
          </b-button>
          <b-button class="btn btn-danger delete" @click.prevent="deleteFreeDay">
            <font-awesome-icon icon="trash-alt" size="xs"></font-awesome-icon>
          </b-button>
        </template>
      </b-col>
      <b-col md="4" order-md="1">
        <span class="label">Od</span>
        <span class="value">{{freeDay.startDate | date}}</span>
      </b-col>
      <b-col md="4" order-md="2">
        <span class="label">Do</span>
        <span class="value">{{freeDay.endDate | date}}</span>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  padding: 7px;
  margin: 3px;
  background: rgba(0, 0, 0, 0.03);
}
.container-fluid {
  padding: 0px;
}
.delete {
  padding: 3px 10px;
  margin-bottom: 5px;
}
.edit {
  padding: 3px 10px;
  margin-bottom: 5px;
  margin-right: 5px;
}
.label {
  font-weight: 600;
}
.value {
  font-style: italic;
  display: block;
  margin-bottom: 10px;
}
</style>
<script>
import moment from "moment";
export default {
  props: ["freeDay"],
  data() {
    return {};
  },
  methods: {
    editFreeDay() {
      this.$emit("edit", this.freeDay.id);
    },
    deleteFreeDay() {
      this.$emit("delete", this.freeDay.id);
    },
    moment: function() {
      return moment();
    }
  },
  filters: {
    date(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "-";
    }
  }
};
</script>
